import apiConfig from '../apiConfig';
import { getAxiosInstance } from '../../utils/axiosApi';
import { fetchHandler } from '../../utils/apiUtils';

const axiosInstance = getAxiosInstance({
  baseUrl: apiConfig.PortalAPIUrl,
});

const searchCylinder = async ({
  clientIDs,
  orderNumber,
  rentalAgreementNumber,
  cylinderType,
  cylinderStatus,
  cylinderSubStatus,
  requestor,
  reportAddressIDs,
  daysOut,
  shippingDateFrom,
  shippingDateTo,
  page,
  pageSize,
  sortBy,
  sortDirection
}, abortController) =>
  fetchHandler(axiosInstance,
    '/CylinderMovement/Search/By', { clientIDs: clientIDs?.join(','),
      orderNumber,
      rentalAgreementNumber,
      cylinderTypeID: cylinderType,
      statusIDs: cylinderStatus,
      subStatusIDs: cylinderSubStatus,
      requestor,
      reportAddressIDs: reportAddressIDs?.join(','),
      daysOutRange: daysOut,
      shippingDateFrom,
      shippingDateTo,
      currentPage: page,
      pageSize,
      sortBy,
      sortDirection }, abortController);

const getDaysOut = async ({ clientIds,
  divisionIds,
  locationIds,
  sourceSystemIds, }, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/DaysOut', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const getCylinderByState = async ({ clientIds,
  divisionIds,
  locationIds,
  sourceSystemIds, }, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/CylinderByState', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const getCylinderByType = async ({ clientIds,
  divisionIds,
  locationIds,
  sourceSystemIds, }, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/CylinderByType', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const getLateFeesBilledYTD = async ({ clientIds,
  divisionIds,
  locationIds,
  sourceSystemIds, }, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/LateFeesBilledYTD', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const getRentalFeesByClient = async ({ clientIds,
  divisionIds,
  locationIds,
  sourceSystemIds, }, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/RentalFeesByClient', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const getLateFeesPending = async ({ clientIds,
  divisionIds,
  locationIds,
  sourceSystemIds, }, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/LateFeesPending', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const getLateFeesPendingByClient = async ({ clientIds,
  divisionIds,
  locationIds,
  sourceSystemIds, }, abortController) =>
  fetchHandler(axiosInstance,
    'DashBoard/LateFeePendingByClient', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const getCylinderActivityByClient = async ({ clientIds,
  divisionIds,
  locationIds,
  sourceSystemIds, }, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/CylinderActivityByClient', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const getCylinderActivityByRequestor = async ({ clientIds,
  divisionIds,
  locationIds,
  sourceSystemIds, }, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/CylinderActivityByRequestor', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const getClientCylinderByStatus = async ({ clientIds,
  divisionIds,
  locationIds,
  sourceSystemIds, }, abortController) =>
  fetchHandler(axiosInstance,
    'DashBoard/ClientCylinderByStatus', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const getClientCylinderReturnTime = async ({ clientIds,
  divisionIds,
  locationIds,
  sourceSystemIds, }, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/GetClientCylinderReturnTime', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const getClientCylinderTotalRepairFees = async ({ clientIds,
  divisionIds,
  locationIds,
  sourceSystemIds, }, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/GetClientCylinderTotalRepairFees', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const getOrderByStatus = async ({ clientIds,
  divisionIds,
  locationIds,
  sourceSystemIds, }, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/GetOrdersByStatus', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const getRecentOrders = async ({ clientIds,
  divisionIds,
  locationIds,
  sourceSystemIds, }, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/GetRecentOrders', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const getOrderbyShipLocation = async ({ dateFrom,
  dateTo,
  clientIds,
  divisionIds,
  locationIds,
  sourceSystemIds, }, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/GetOrderbyShipLocation', { dateFrom,
      dateTo,
      clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','), }, abortController);

const getOrderbyMaterialAndStatus = async ({ clientIds,
  divisionIds,
  locationIds,
  sourceSystemIds,
  latitude,
  longitude }, abortController) =>
  fetchHandler(axiosInstance,
    '/DashBoard/GetOrderbyMaterialAndStatus', { clientIds: clientIds?.join(','),
      divisionIds: divisionIds?.join(','),
      locationIds: locationIds?.join(','),
      sourceSystemIds: sourceSystemIds?.join(','),
      latitude,
      longitude }, abortController);

const cylinderApi = {
  searchCylinder,
  getDaysOut,
  getCylinderByState,
  getCylinderByType,
  getLateFeesBilledYTD,
  getRentalFeesByClient,
  getLateFeesPending,
  getLateFeesPendingByClient,
  getCylinderActivityByClient,
  getCylinderActivityByRequestor,
  getClientCylinderByStatus,
  getClientCylinderReturnTime,
  getClientCylinderTotalRepairFees,
  getOrderByStatus,
  getRecentOrders,
  getOrderbyShipLocation,
  getOrderbyMaterialAndStatus,
};

export default cylinderApi;
